export default "__VITE_PUBLIC_ASSET__6c89ce5f__"